import axios from 'axios';
import { Task, TaskFormData } from '../types';

// 创建 axios 实例
const apiClient = axios.create({
    baseURL: '/api',
    headers: {
        'Content-Type': 'application/json'
    }
});

// API 服务对象
const api = {
    // 获取所有任务
    getTasks: () => {
        return apiClient.get<Task[]>('/tasks');
    },

    // 获取单个任务
    getTask: (id: number) => {
        return apiClient.get<Task>(`/tasks/${id}`);
    },

    // 创建新任务
    createTask: (task: TaskFormData) => {
        return apiClient.post<Task>('/tasks', task);
    },

    // 更新任务
    updateTask: (id: number, task: TaskFormData) => {
        return apiClient.put<Task>(`/tasks/${id}`, task);
    },

    // 更新任务状态
    updateTaskStatus: (id: number, status: string, is_reset: boolean) => {
        return apiClient.put<Task>(`/tasks/${id}/status`, { status, is_reset });
    },

    // 删除任务
    deleteTask: (id: number) => {
        return apiClient.delete(`/tasks/${id}`);
    }
};

export default api;